module.exports = __webpack_public_path__ + "img/im_scrollfeature_17.21596c36.jpg";